import React from 'react';
import { validateRulesFieldValue } from 'components/util/validation';
import { Stack, TextField, getTheme } from '@fluentui/react';
import { settingsFieldStyles } from '../admin/SettingsStyles';

interface TimeFieldProps {
  value: number;
  onComponentChange: (timeInSeconds) => void;
}

// TODO Deliverable https://microsoft.visualstudio.com/Xbox/_workitems/edit/37800976
// TODO: Unify TimeFieldGeneric and TimeField
export const TimeFieldGeneric: React.FC<TimeFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const [hours, setHours] = React.useState<number>(Math.floor(props.value / 3600));
  const [minutes, setMinutes] = React.useState<number>(Math.floor((props.value - hours * 3600) / 60));

  let HH: number;
  let MM: number;

  const onComponentChange = (result: number, fieldName: string): void => {
    let correctResult: number;
    result = isNaN(result) ? 0 : result;
    switch (fieldName) {
      case 'hours':
        correctResult = Number(validateRulesFieldValue(String(result), 0, 1000));
        setHours(correctResult);
        HH = correctResult;
        break;
      case 'minutes':
        correctResult = Number(validateRulesFieldValue(String(result), 0, 59));
        setMinutes(correctResult);
        MM = correctResult;
        break;
    }
    const timeInSeconds = (HH != undefined ? HH : hours) * 3600 + (MM != undefined ? MM : minutes) * 60;

    props.onComponentChange(timeInSeconds);
  };

  return (
    <Stack horizontal tokens={{ childrenGap: 15 }}>
      <Stack.Item>
        <TextField
          onChange={(e): void => onComponentChange(parseInt(e.currentTarget.value), 'hours')}
          label={'Hours'}
          value={hours.toString()}
          styles={settingsFieldStyles(palette, fonts, 60)}
          maxLength={4}
        />
      </Stack.Item>
      <Stack.Item>
        <TextField
          onChange={(e): void => onComponentChange(parseInt(e.currentTarget.value), 'minutes')}
          label={'Minutes'}
          value={minutes.toString()}
          styles={settingsFieldStyles(palette, fonts, 60)}
          maxLength={2}
        />
      </Stack.Item>
    </Stack>
  );
};
